module.exports = __webpack_public_path__ + "img/returns.3318b2d9.svg";